import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { http } from "../../utils";
import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks/use-pagination-query";

export async function fetchPatientById(patientId) {
  const { data } = await http(`/admin/users/${patientId}`);

  return data;
}

export function usePatientById(ref) {
  const { data, ...raResult } = useQuery(["patient-detail", ref], () =>
    fetchPatientById(ref)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}

async function deletePatient(patientId) {
  const data = await http(`/admin/hospitals/${patientId}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeletePatient() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deletePatient, {
    onSuccess: () => {
      queryClient.invalidateQueries(["patient"]);
      navigate("/member-management");
    },
  });
}

function fetchPatientHospitalList(params, id) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL(`/admin/users-hospital?userId=${id}`, baseUrl);

  if (params.name) {
    endpointUrl.searchParams.append("name", params.name);
  }

  if (params.address) {
    endpointUrl.searchParams.append("address", params.address);
  }

  if (params.contact) {
    endpointUrl.searchParams.append("contact", params.contact);
  }

  if (params.email) {
    endpointUrl.searchParams.append("email", params.email);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function usePatientHospitallist(params = {}, id) {
  return usePaginationQuery(
    [
      "patient-hospitals",
      params.name,
      params.address,
      params.contact,
      params.email,
      id,
    ],
    (paginationState) =>
      fetchPatientHospitalList({ ...params, ...paginationState }, id)
  );
}
